import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/RecruitPage.module.css';
import WireframeBackground from '../components/WireframeBackground';

function Recruit() {
    const [openFaq, setOpenFaq] = useState(null);

    const toggleFaq = (index) => {
        setOpenFaq(openFaq === index ? null : index);
    };

    const faqData = [
        {
            category: "１. 働く環境・制度に関するもの",
            items: [
                { q: "PCやツールの支給はありますか？", a: "業務に必要な機材は全て支給します。通信費・光熱費手当もあります。" },
                { q: "出張はありますか？", a: "基本的にはありませんが、採用目的で専門学校への個別訪問、プロジェクト打ち上げ（または試写会）、年に一度の全社ミートアップについては出張扱いとなります。" },
                { q: "他のメンバーとの関わりは十分取れますか？", a: "プロジェクトによって密度は異なりますが、毎週月曜の全体ミーティング、毎週水曜のチームミーティング、隔週の上長との1on1を設定しています。またオンラインでの懇親会も不定期で開催しています。" },
                { q: "副業は可能ですか？", a: "副業は本業への支障がない範囲であれば原則自由ですが、会社への報告義務を設けています。また本業（リグ）の仕事については競業のリスクの関係で禁止しています。" },
                { q: "社員としての採用ですか？", a: "入社当初は契約社員としての採用ですが、積極的な正社員への登用を行っています。" },
                { q: "試用期間はどの程度ですか？", a: "中途入社の場合3カ月、新卒入社の場合半年間の試用期間を設けています。待遇面では通常の雇用と同じ扱いとなります。" }
            ]
        },
        {
            category: "２. 業務・技術・育成に関するもの",
            items: [
                { q: "育成はどのように行われますか？", a: "新人採用の場合：入社後約半年間の研修を実施します。リーダーがチェックを担当し、キャラクターの全身、髪、服、表情まで幅広く経験していただきます。その後、OJTを通じて実務に入りながらスキルアップを支援します。\n中途採用の場合： 入社後に会社標準仕様でのトレーニングを約1ヶ月間実施し、その後、経験・スキルに応じたプロジェクトにアサインします。\n入社後は、個々のスキルセットと成長目標に基づき、Off-JT（研修）とOJT（実務を通じた育成）の両面から計画的に人材育成を行います。" }
            ]
        },
        {
            category: "３. 待遇・福利厚生に関するもの",
            items: [
                { q: "給料・賞与はどの程度ですか？", a: "新卒の初任給は22万円としています。中途社員の報酬は、応募者の経験等をふまえて判断させていただきます。\n賞与は毎年の業績により変動しますが、2025年の支給実績として月給の1-2ヶ月を支給しています。" },
                { q: "福利厚生はどのようなものがありますか？", a: "以下の福利厚生を提供しています。\n・通信費・光熱費補助\n・フレックスタイム制・フルリモート制\n・書籍購入・外部研修補助（希望制）\n・夏季休暇、年末年始休暇" },
                { q: "住宅手当やリモートワーク手当はありますか？", a: "住宅手当やリモートワーク手当としての名目ではありませんが、通信費・光熱費補助を支給しています。" }
            ]
        },
        {
            category: "４. 選考プロセス・その他",
            items: [
                { q: "選考期間はどの程度ですか？", a: "応募から内定まで、概ね２週間程度を見込んでいます。" },
                { q: "選考フローを教えてください", a: "書類審査 → １次面接 → ２次面接 → 採用 となります。" },
                { q: "面接はオンラインですか？", a: "面接は原則オンラインで実施いたします。" },
                { q: "社員に話を聞きたいのですがどうしたら良いですか？", a: "弊社ホームページの「お問い合わせ」よりお気軽にお問い合わせください。" }
            ]
        }
    ];

    return (
        <div className={styles.container}>
            <WireframeBackground />
            <div className={styles.wrap}>
                <section className={styles.recruitSection}>
                    {/* ページタイトル */}
                    <div className={styles.header}>
                        <h2 className={styles.sectionTitle}>RECRUIT</h2>
                        <p className={styles.subtitle}>採用情報</p>
                    </div>

                    {/* ① 採用情報トップ（ヒーローセクション） */}
                    <div className={styles.heroSection}>
                        <div className={styles.heroContent}>
                            <div className={styles.messageBox}>
                                <div className={styles.messageDecoration}></div>
                                <p className={styles.mainMessage}>
                                    あなたの情熱と専門性を解き放つ場が、Parnasにはあります。<br />
                                    私たちと一緒に、CG業界に変革を起こしましょう。
                                </p>
                            </div>
                        </div>
                        <div className={styles.heroImageContainer}>
                            <img src="/images/VRchara_web_normal.png" alt="Recruit Hero" className={styles.heroImage} />
                            <div className={styles.heroOverlay}></div>
                        </div>
                        {/* ヒーローセクションの装飾 */}
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                    </div>

                    <div className={styles.content}>
                        {/* ② Parnasのビジョン */}
                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>
                            <h3 className={styles.title}>Parnasのビジョン</h3>
                            <div className={styles.visionBox}>
                                <p className={styles.visionStatement}>"全てのデジタルアセットに命を吹き込む”</p>
                                <p className={styles.description}>
                                    私たちParnasは、このビジョンを実現するため、日々技術を磨き続けています。<br />
                                    CGのリギング技術は、ゲーム、アニメ、広告コンテンツの品質を左右する横断的な専門スキルです。私たちは、この専門性を武器に、ジャンルを問わずコンテンツ制作を支援し、世界中の人々の生活にささやかな感動を届けられるよう、一つ一つのアセットに魂を吹き込むことを目標にしています。
                                </p>
                            </div>
                        </div>

                        {/* ④ Parnasで働く意味 */}
                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>
                            <h3 className={styles.title}>Parnasで働く意味（得られるもの）</h3>
                            <p className={styles.introText}>当社の最大の強みは、「クリエイターとしての確かな成長」と「長期的に活躍できる安定した仕事環境」の両立です。</p>

                            <div className={styles.subSection}>
                                <h4 className={styles.subTitle}>1. クリエイターとしての確かな成長</h4>
                                <p className={styles.description}>
                                    日本にはリグに特化した会社はほとんど存在しません。そのため、実力あるクリエイターが「他社のワークフローに触れたい」「自分で新しい仕様を組んでみたい」と考えたとき、その環境を見つけることは困難でした。<br />
                                    Parnasでは、社内仕様から他社仕様まで常時複数のプロジェクトが稼働しています。これにより、一般的なスタジオでは得られない、圧倒的な数の実力向上の機会が常に用意されています。
                                </p>
                                <p className={styles.subDescription}>加えて、クリエイターの成長のため、下記の施策を講じています。</p>
                                <ul className={styles.featuresList}>
                                    <li>個々の成長目標を毎年丁寧に議論し、次なるプロジェクトアサインの指針とします。</li>
                                    <li>プロジェクトの合間には積極的なトレーニング期間を設け、常にスキルアップと成長のための時間を確保しています。</li>
                                </ul>
                            </div>

                            <div className={styles.subSection}>
                                <h4 className={styles.subTitle}>2. 長期的に活躍できる安定した仕事環境</h4>
                                <p className={styles.description}>
                                    私たちは、フルリモート体制こそがクリエイターの生産性向上のための最重要戦略だと考えています。物理的な制約に囚われた従来の働き方から解放され、バーチャル空間で最高のパフォーマンスを発揮する手法を構築しています。<br />
                                    仕事環境は完全在宅です。これにより、ご家族との時間を大切にしながら、仕事に集中することが可能です。結婚、育児、親の介護など、人生の様々なライフステージにおいて、在宅勤務ならではの柔軟な働き方がクリエイターとしてのキャリア継続を強力に支えます。
                                </p>
                            </div>
                        </div>

                        {/* ⑤ リードリギングアーティストの声 */}
                        <div className={styles.voiceSection}>
                            <h3 className={styles.sectionHeading}>LEAD ARTIST VOICES</h3>
                            <div className={styles.voiceGrid}>
                                <div className={styles.voiceCard}>
                                    <div className={styles.cornerTL}></div>
                                    <div className={styles.cornerBR}></div>
                                    <div className={styles.artistInfo}>
                                        <span className={styles.artistName}>R.Yanagi</span>
                                        <p className={styles.voiceQ}>パルナスはどんな会社ですか？</p>
                                        <p className={styles.voiceA}>社員のことを第一に考えている会社だと思います。働き方や福利厚生など社員の意見を聞き取り入れてもらえているのでかなり助かっています。</p>
                                        <p className={styles.voiceQ}>どんなメンバーに来てほしいですか？</p>
                                        <p className={styles.voiceA}>向上心がある方💪責任感を持てる方👓</p>
                                    </div>
                                </div>
                                <div className={styles.voiceCard}>
                                    <div className={styles.cornerTL}></div>
                                    <div className={styles.cornerBR}></div>
                                    <div className={styles.artistInfo}>
                                        <span className={styles.artistName}>R.Nonaka</span>
                                        <p className={styles.voiceQ}>パルナスはどんな会社ですか？</p>
                                        <p className={styles.voiceA}>質問しやすい雰囲気があり、社員同士の連携も取れていますが、仕事においては締めるところは締めて堅実に作業できている会社だと思います。</p>
                                        <p className={styles.voiceQ}>どんなメンバーに来てほしいですか？</p>
                                        <p className={styles.voiceA}>学ぶ姿勢があり真摯に取り組んでいただける方だと嬉しいです!!</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ⑥ 働き方 */}
                        <div className={styles.infoCard} id="work-style">
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>
                            <h3 className={styles.title}>働き方</h3>
                            <p className={styles.description}>Parnasは、クリエイターが最高のパフォーマンスを発揮し続けるために、「完全リモートワーク」と「メリハリのある働き方」を根幹に据えています。</p>
                            <ul className={styles.workStyleList}>
                                <li><strong>完全在宅勤務</strong></li>
                                <li><strong>完全週休二日制</strong></li>
                                <li><strong>フレックスタイム制</strong></li>
                                <li><strong>チームコミュニケーション（Slack）</strong></li>
                                <li><strong>年に一度の全社ミートアップ（対面）</strong></li>
                            </ul>
                        </div>

                        {/* ⑦ 募集職種一覧／採用人数 */}
                        <div className={styles.recruitGrid} id="job-openings">
                            <div className={styles.categoryCard}>
                                <h3 className={styles.title}>募集職種一覧 ／ 採用人数</h3>
                                <ul className={styles.jobList}>
                                    <li>リギングアーティスト（経験２年以上）</li>
                                    <li>リギングアーティスト（新卒）</li>
                                    <li>プロデューサー候補・進行スタッフ（経験3年以上）</li>
                                </ul>
                            </div>
                            {/* ⑧ 募集要項 */}
                            <div className={styles.categoryCard}>
                                <h3 className={styles.title}>募集要項</h3>
                                <div className={styles.linkList}>
                                    <Link to="/recruitInfo#artists" className={styles.textLink}>リギングアーティスト ＞</Link>
                                    <Link to="/recruitInfo#producers" className={styles.textLink}>制作進行 ＞</Link>
                                    {/* <Link to="/recruitIntern" className={styles.textLink}>インターン募集 ＞</Link> */}
                                </div>
                            </div>
                        </div>

                        {/* ⑨ 採用選考フロー／応募方法 */}
                        <div className={styles.infoCard}>
                            <div className={styles.cornerTL}></div>
                            <div className={styles.cornerTR}></div>
                            <div className={styles.cornerBL}></div>
                            <div className={styles.cornerBR}></div>
                            <h3 className={styles.title}>採用選考フロー ／ 応募方法</h3>
                            <ol className={styles.flowList}>
                                <li>弊社問い合わせより応募（履歴書とポートフォリオを添付ください）</li>
                                <li>書類選考</li>
                                <li>１次面接</li>
                                <li>２次面接</li>
                                <li>採用</li>
                            </ol>
                            <div className={styles.applyBox}>
                                <Link to="/contact" className={styles.linkButton}>お問い合わせはこちら</Link>
                            </div>
                        </div>

                        {/* ⑩ FAQ（採用） */}
                        <div className={styles.faqSection} id="recruit-faq">
                            <h3 className={styles.sectionHeading}>RECRUIT FAQ</h3>
                            {faqData.map((category, catIdx) => (
                                <div key={catIdx} className={styles.faqCategory}>
                                    <h4 className={styles.faqCategoryTitle}>{category.category}</h4>
                                    <div className={styles.faqList}>
                                        {category.items.map((item, idx) => {
                                            const itemIdx = `${catIdx}-${idx}`;
                                            const isOpen = openFaq === itemIdx;
                                            return (
                                                <div key={idx} className={`${styles.faqItem} ${isOpen ? styles.open : ''}`}>
                                                    <div className={styles.faqQuestion} onClick={() => toggleFaq(itemIdx)}>
                                                        <span className={styles.qMark}>Q.</span>
                                                        <span className={styles.qText}>{item.q}</span>
                                                        <span className={styles.arrow}>{isOpen ? '−' : '+'}</span>
                                                    </div>
                                                    <div className={styles.faqAnswerWrapper}>
                                                        <div className={styles.faqAnswer}>
                                                            <div className={styles.aContent}>
                                                                <span className={styles.aMark}>A.</span>
                                                                <p>{item.a.split('\n').map((line, i) => <React.Fragment key={i}>{line}<br /></React.Fragment>)}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default Recruit;